import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('dm_token') : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const listingsApi = {
  list: (params = {}) => client.get('/listings', { params }).then((r) => r.data),
  detail: (slug) => client.get(`/listings/${slug}`).then((r) => r.data),
  neighbors: (slug, params = {}) => client.get(`/listings/${slug}/neighbors`, { params }).then((r) => r.data),
  create: (data) => client.post('/listings', data).then((r) => r.data),
  update: (id, data) => client.put(`/listings/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/listings/${id}`).then((r) => r.data),
  sendMessage: (listingId, data) => client.post(`/listings/${listingId}/messages`, data).then((r) => r.data),
};

export const meApi = {
  listings: () => client.get('/me/listings').then((r) => r.data),
  threads: () => client.get('/me/threads').then((r) => r.data),
  thread: (threadId) => client.get(`/me/threads/${threadId}`).then((r) => r.data),
  reply: (threadId, body) => client.post(`/me/threads/${threadId}/reply`, { body }).then((r) => r.data),
  deleteThread: (threadId) => client.delete(`/me/threads/${threadId}`).then((r) => r.data),
  unreadCount: () => client.get('/me/messages/unread-count').then((r) => r.data),
  // legacy
  messages: () => client.get('/me/messages').then((r) => r.data),
  markRead: (id) => client.patch(`/me/messages/${id}/read`).then((r) => r.data),
  deleteMessage: (id) => client.delete(`/me/messages/${id}`).then((r) => r.data),
};

export const uploadsApi = {
  image: (file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return client.post('/uploads/image', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    }).then((r) => ({ ...r.data, absUrl: `${BACKEND_URL}${r.data.url}` }));
  },
  video: (file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return client.post('/uploads/video', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    }).then((r) => ({ ...r.data, absUrl: `${BACKEND_URL}${r.data.url}` }));
  },
};

export const toAbs = (url) => {
  if (!url) return url;
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}${url}`;
};

export const authApi = {
  register: (data) => client.post('/auth/register', data).then((r) => r.data),
  login: (data) => client.post('/auth/login', data).then((r) => r.data),
  me: () => client.get('/auth/me').then((r) => r.data),
};

export const adminApi = {
  import: (listings, replace_existing = false) =>
    client.post('/admin/import', { listings, replace_existing }).then((r) => r.data),
  stats: () => client.get('/admin/stats').then((r) => r.data),
  generateSamples: (count) => client.post('/admin/generate-samples', { count }).then((r) => r.data),
  deleteSamples: () => client.delete('/admin/samples').then((r) => r.data),
};

export const metaApi = {
  get: () => client.get('/meta').then((r) => r.data),
};

export default client;
